// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IntroPage-module__intro-page--HjZ3K {
  position: relative;
  width: 100%;
  min-height: 1100px;
  margin: 0 auto;
  background: #090a0c;
}

.IntroPage-module__wrap--PULKI {
  width: var(--layout-width);
  margin: 0 auto;
}`, "",{"version":3,"sources":["webpack://./src/pages/IntroPage/IntroPage.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB","sourcesContent":[".intro-page {\n  position: relative;\n  width: 100%;\n  min-height: 1100px;\n  margin: 0 auto;\n  background: #090a0c;\n}\n\n.wrap {\n  width: var(--layout-width);\n  margin: 0 auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"intro-page": `IntroPage-module__intro-page--HjZ3K`,
	"wrap": `IntroPage-module__wrap--PULKI`
};
export default ___CSS_LOADER_EXPORT___;
